import qs from 'qs'
import request from '@/modules/base/util/request'
import config from 'config'

const baseUrl = `${config.resourceHost}subscription`
const baseUrlModuleSubscription = `${config.resourceHost}moduleSubscription`

export const SubscriptionService = {
  create: (subscription) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: subscription,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  createTrials: (subscriptionTypeTypes) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}/trials`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { subscriptionTypeTypes },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  getWebSubscriptionTypes: (type) => {
    return new Promise((resolve, reject) => {
      let url = `${baseUrl}/web/types`
      url = type ? `${url}?type=${type}` : url
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getProductsMbo: () => {
    return new Promise((resolve, reject) => {
      return request(`${baseUrl}/products`, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getSpecificDetails: (queryParams = {}) => {
    const querystring = qs.stringify(queryParams)
    return new Promise((resolve, reject) => {
      return request(`${baseUrl}/specific-detail?${querystring}`, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  moduleSubscriptions: {
    getAvailableModules: () => {
      return new Promise((resolve, reject) => {
        const url = `${baseUrlModuleSubscription}/available`
        return request(url, { auth: true, isConcurrent: true })
          .then(response => {
            const { body } = response
            resolve(body)
          })
          .catch(error => reject(error))
      })
    },
    createModules: ({ billingData, modules, period = '' }) => {
      return new Promise((resolve, reject) => {
        const url = `${baseUrlModuleSubscription}`
        return request(url, {
          auth: true,
          isConcurrent: true,
          method: 'POST',
          data: { billingData, modules, period },
        })
          .then(response => {
            const { body } = response
            resolve(body)
          })
          .catch(error => reject(error))
      })
    },
    getModulesOfSubscriptionType: (type) => {
      return new Promise((resolve, reject) => {
        const url = `${baseUrlModuleSubscription}/modules/${type}`
        return request(url, {
          auth: true,
          isConcurrent: true,
        })
          .then(response => resolve(response?.body))
          .catch(error => reject(error))
      })
    },
  },
}

export default SubscriptionService
